import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { IconButton } from '../../components/Button/IconButton'
import { ButtonThemeType } from '../../components/Button'

const SchoolOverviewButton = styled(IconButton).attrs({
  theme: ButtonThemeType.NORMAL,
  inline: true,
})`
  background-image: none;
  margin: ${STYLES.GUTTER} ${STYLES.GUTTER} 0 0;
  border-color: ${STYLES.COLOR_HIT_GRAY};
  color: ${STYLES.PRIMARY_COLOR};
  background-color: ${STYLES.COLOR_WHITE};
  font-size: ${STYLES.FONT_SIZE_MD};
  span {
    color: ${STYLES.TEXT_COLOR};
    font-size: ${STYLES.FONT_SIZE_SM};
  }
  &:hover {
    background-image: none;
    background-color: ${STYLES.COLOR_WHITE};
  }
`

export { SchoolOverviewButton }
